// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Fidelity */
export const Fidelity = createBankIcon({
  name: "Fidelity",
  slug: "fidelity",
  compe: null,
  color: "#ee2722",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#ee2722;fill-opacity:1\"\n     id=\"fidelity_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(-0.1736,-1.5862) scale(0.16619)\">\n    <path d=\"M 301,193 l 0,65 110,0 -18,39 -92,0 0,30 79,0 -18,39 -61,0 0,119 -69,0 0,-119 -39,0 0,-39 39,0 0,-30 -39,0 0,-39 39,0 0,-122 179,0 0,57\" style=\"fill:#ffffff\" fill-rule=\"evenodd\" />\n  </g>",
});
